import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatOptionSelectionChange } from '@angular/material/core';
import { BaseForm } from '@forms/base.form';
import { TrainingProgram } from '@models/training/training-program.model';
import { ReportFilter } from '@reporting/interfaces/report-filter.interface';
import { TranslatableKey } from '@app/types/translatable.type';

interface SelectOption {
    label: TranslatableKey;
    id: null | string | number;
}

@Component({
    selector: 'app-form-training-report-filter',
    templateUrl: './training-report-filter-form.html',
    styleUrls: ['./training-report-filter-form.style.scss'],
})
export class TrainingReportFilterForm extends BaseForm implements OnInit {
    default: SelectOption = { id: null, label: 'reporting.reports.trainingReport.allPrograms' };
    options: SelectOption[] = [this.default];
    programsFormControl = new FormControl();

    showHistory = false;
    showTerminated = false;

    constructor() {
        super();
    }

    get filters(): ReportFilter[] {
        return [
            {
                name: 'training_programs',
                value: this.programsFormControl.value.map((option: SelectOption) => option.id),
            },
            {
                name: 'employees',
                value: this.showTerminated ? true : null,
            },
            {
                name: 'records',
                value: this.showHistory ? true : null,
            },
        ];
    }

    ngOnInit(): void {
        TrainingProgram.query()
            .orderBy('name', 'asc')
            .all()
            .then(([programs]: [TrainingProgram[], any]) => {
                this.options = this.options.concat(
                    programs.map((program) => ({ id: program.id, label: program.name }))
                );
                this.programsFormControl.setValue(this.options);
            });
    }

    onProgramSelect(event: MatOptionSelectionChange, selection: SelectOption): void {
        if (!event.isUserInput) {
            return;
        }

        // on select all, selection, toggle other options on or off
        if (selection === this.default) {
            this.programsFormControl.setValue(event.source.selected ? this.options : []);
            return;
        }
        // on program toggle off, make sure we turn off "select all" if enabled
        if (
            !event.source.selected &&
            selection !== this.default &&
            this.programsFormControl.value.indexOf(this.default) >= 0
        ) {
            const newOpts = this.programsFormControl.value.filter((opt) => opt !== this.default && opt !== selection);
            this.programsFormControl.patchValue(newOpts);
            return;
        }
    }
}
